<template>
  <div class="server-response-503">
    <div class="server-img-cont">
      <img src="@/assets/server.png" alt="Server"/>
    </div>
    <div class="texts">
      <div class="barter-logo">
        <img src='@/assets/barter-full.png' alt='logobarter'>
      </div>
      <h2>Server Maintenance</h2>
      <p>
        We sincerely apologize for the inconvenience.
        Barter XI is currently under maintenance.
        Please try again later or contact us.
      </p>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.server-response-503 {
  display: flex;
}

.server-img-cont {
  align-items: center;
  display: flex;
}

.server-response-503 .texts {
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 30px;
}

.server-response-503 .texts h2 {
  font-size: 40px;
  margin-bottom: 0;
  text-align: center;
}

.server-response-503 .texts p {
  color: #777;
  font-weight: 600;
  line-height: 200%;
  text-align: center;
  white-space: pre-line;
}

.barter-logo {
  margin-bottom: 20px;
  text-align: center;
}

.barter-logo img {
  height: 70px;
}

@media only screen and (max-width: 1000px) {
  .server-img-cont img {
    height: 200px;
  }

  .server-response-503 .texts .barter-logo img {
    height: 50px;
  }

  .server-response-503 .texts h2 {
    font-size: 30px;
  }
}

@media only screen and (max-width: 720px) {
  .server-response-503 .texts h2 {
    font-size: 26px;
  }
}

@media only screen and (max-width: 580px) {
  .server-response-503 {
    flex-direction: column;
  }

  .server-response-503 .server-img-cont {
    display: flex;
    justify-content: center;
    margin-bottom: 20px;
  }

  .server-response-503 .texts {
    margin-left: 0;
  }
}
</style>
